import React, { useState } from "react";
import _ from "lodash";
import { reduxForm, Field } from "redux-form";
import {
  Form,
  Grid,
  Header,
  Image,
  Icon,
  Card,
  Divider,
} from "semantic-ui-react";
import DatePicker from "react-datepicker";
import { TextInput, SelectInput } from "../utils/form-fields";
import { ApiRequest } from "../../firebase/server";
import { buildFastrade, linkChoice } from "../utils/fastrade";

import loadingImage from "../../images/30.gif";

let Fastrade = ({ savedTpnb, bannerChange, handleSubmit }) => {
  const [values, setValues] = useState({
    tpnb: "",
    tpnc: "",
    response: null,
  });
  const [links, setLinks] = useState({
    vtValue: "",
    linkValue: "",
  });
  const [spectraImages, setSpectraImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showTpnbError, setShowTpnbError] = useState(false);
  const [startDate, setStartDate] = useState(new Date());

  const handleSelectedImage = (data) => {
    setSelectedImage(data.name);
    let url = data.originalUrl
      ? `${data.originalUrl}?w=300`
      : data.image.replace("90x90", "225x225");
    bannerChange("primaryPackshot", {
      path: url,
      name: data.name,
    });
  };

  const handleRadio = (e, { name, value }) => {
    if (name === "link-choice") {
      setLinks({ ...links, linkValue: value });
      linkChoice(value, values.response).then((result) => {
        let keys = Object.keys(result);
        keys.map((key) => {
          return bannerChange(key, result[key]);
        });
      });
    }
  };

  const createFastradeBanner = (data) => {
    let keys = Object.keys(data);
    keys.map((key) => {
      return bannerChange(key, data[key]);
    });
  };

  const getSpectraImages = (tpnb, fasTrade) => {
    ApiRequest({
      tpnb: tpnb,
      retailer: "tesco",
      service: "spectra",
    })
      .then((results) => {
        setSpectraImages(results.result.mediaSummaries);
        createFastradeBanner(fasTrade);
        setShowLoading(false);
      })
      .catch((error) => {
        console.log("spectra error", error);
        setSpectraImages([]);
        createFastradeBanner(fasTrade);
        setShowLoading(false);
      });
  };

  const handleSubmitForm = (vals) => {
    const formDate = startDate.toISOString();

    setShowTpnbError(false);
    setSpectraImages([]);
    setLinks({ vtValue: "", linkValue: "" });
    setValues({ ...values, ...vals, response: null });
    let prodTpnb = "";

    setShowLoading(true);

    ApiRequest({
      tpnb: vals.tpnb,
      tpnc: vals.tpnc,
      storeId: vals.store,
      retailer: "tesco",
      service: "fastrade",
      country: vals.country,
      date: formDate,
    })
      .then((results) => {
        const { result } = results;
        //console.log("Fastrade api request result", result);
        const { gtin, tpnc, description, digitalContent } = result.productData;
        prodTpnb = result.productData.tpnb;
        const { sellingPrice } = result.priceData;

        let thumb = digitalContent
          ? `${digitalContent[0].url}?h=272&w=272`
          : "";

        return {
          id: tpnc,
          tpnb: prodTpnb,
          name: description,
          image: thumb,
          gtin: gtin,
          price: sellingPrice,
          promotions: result.promoData,
          currency: result.priceData.currency,
        };
      })
      .then((data) => {
        setValues({
          ...values,
          response: data,
        });
        setShowError(false);
        return buildFastrade(data);
      })
      .then((fsresult) => {
        getSpectraImages(prodTpnb, fsresult);
      })
      .catch((error) => {
        const errorMsg = error.message || error.data || error.response.data;
        console.log("fastrade error", errorMsg);
        setShowError(errorMsg);
        setShowLoading(false);
        setShowTpnbError(`${errorMsg}`);
      });
  };

  const renderResponse = () => {
    const data = values.response;
    return _.map(data, (item, key) => {
      if (key === "promotions") {
        return _.map(item, (v, i) => {
          return (
            <li key={i}>
              promotion: {i + 1}
              <ul>
                {_.isArray(v) &&
                  _.map(v, (value, index) => {
                    return (
                      <li key={index}>
                        {index}: {value}
                      </li>
                    );
                  })}
              </ul>
            </li>
          );
        });
      }
      return (
        <li key={key}>
          {key}: {typeof item === "boolean" ? "true" : item}
        </li>
      );
    });
  };

  const renderImages = (images) => {
    return _.map(images, (image) => {
      let active = selectedImage === image.name ? "activated" : "inactive";
      let url = image.originalUrl ? `${image.originalUrl}?w=100` : image.image;
      return (
        <Card key={image.id} className={active}>
          <Image
            src={url}
            alt={image.name}
            size="tiny"
            verticalAlign="middle"
            onClick={(e) => handleSelectedImage(image)}
          />
          <ul>
            <li>type: {image.type ? image.type : "jpg"}</li>
            <li>
              resolution: {image.resolution ? image.resolution : "225x255"}
            </li>
            {image.humanReadableSize && (
              <li>size: {image.humanReadableSize}</li>
            )}
          </ul>
          {selectedImage === image.name && (
            <div className="selected">
              <Icon name="check" color="green" />
            </div>
          )}
        </Card>
      );
    });
  };

  return (
    <Grid padded className="fastrade">
      <Grid.Row>
        <Grid.Column computer={8} tablet={8} mobile={16}>
          <Form onSubmit={handleSubmit(handleSubmitForm)} size="mini">
            {savedTpnb && <Header as="h5">TPNB: {savedTpnb}</Header>}
            {showTpnbError && <p className="error">{showTpnbError}</p>}
            <Form.Group>
              <Field
                name="tpnb"
                label="TPNB"
                type="text"
                component={TextInput}
                placeholder="Enter TPNB"
              />
              <Field
                name="tpnc"
                label="Product ID"
                type="text"
                component={TextInput}
                placeholder="Enter a Product ID"
              />
              <Field
                name="store"
                label="Store ID (optional)"
                type="text"
                component={TextInput}
                placeholder="Enter a store ID"
              />
              <Field
                name="country"
                label="Country"
                type="text"
                component={SelectInput}
                options={[
                  { text: "GB", value: "GB", key: "GB" },
                  { text: "IE", value: "IE", key: "IE" },
                ]}
                multiple={false}
              />
              <div className="field">
                <label>Date</label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </div>
              <Form.Button
                type="submit"
                positive
                size="mini"
                loading={showLoading}
              >
                Submit
              </Form.Button>
            </Form.Group>
          </Form>
        </Grid.Column>
        <Grid.Column computer={8} tablet={8} mobile={16}>
          {values.response && values.response.promotions && (
            <Form className="link-choices">
              <Form.Group inline>
                <label>Link choices:</label>
                <Form.Radio
                  label="PDP"
                  value="pdp"
                  name="link-choice"
                  checked={links.linkValue === "pdp"}
                  onChange={handleRadio}
                />
                <Form.Radio
                  label="Offer"
                  value="offer"
                  name="link-choice"
                  checked={links.linkValue === "offer"}
                  onChange={handleRadio}
                />
              </Form.Group>
            </Form>
          )}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column computer={5} tablet={5} mobile={16}>
          {values.response && (
            <div>
              <Header as="h5">Product info</Header>
              <pre>
                <ul>{renderResponse()}</ul>
              </pre>
            </div>
          )}
        </Grid.Column>
        <Grid.Column computer={11} tablet={11} mobile={16}>
          {values.response && !values.response.error && (
            <div className="tierone-list">
              <Header as="h5">Main product image</Header>
              <Card.Group>{renderImages([values.response])}</Card.Group>
            </div>
          )}
          {values.response && (
            <div className="tierone-list">
              <Divider />
              <Header as="h5">Spectra images</Header>
              {showError && (
                <p>
                  Sorry there was an error fetching images. Please try again
                </p>
              )}
              {showLoading && <img src={loadingImage} alt="loading" />}
              {!showLoading && spectraImages.length === 0 && (
                <p>Sorry, no images available</p>
              )}
              {spectraImages.length > 0 && (
                <Card.Group itemsPerRow={3}>
                  {renderImages(spectraImages)}
                </Card.Group>
              )}
            </div>
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

const validate = (vals) => {
  const errors = {};

  if (!vals.tpnc && !vals.tpnb) {
    errors.tpnb = "Please enter a TPNB";
    errors.tpnc = "or a Product ID";
  }
  if (vals.tpnb) {
    if (vals.tpnb.length < 8) errors.tpnb = "Please enter a valid TPNB";
  }
  if (vals.tpnc) {
    if (vals.tpnc.length < 9) errors.tpnc = "Please enter a valid Product ID";
  }

  return errors;
};

Fastrade = reduxForm({
  validate,
  form: "fastradeForm",
})(Fastrade);

export default Fastrade;
